var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 4H3.33333H14",
    stroke: "#293755",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 4H3.33333H14",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 4H3.33333H14",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 4H3.33333H14",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 4H3.33333H14",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 4H3.33333H14",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 4H3.33333H14",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 4H3.33333H14",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 4H3.33333H14",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 4H3.33333H14",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6673 4.00065V13.334C12.6673 13.6876 12.5268 14.0267 12.2768 14.2768C12.0267 14.5268 11.6876 14.6673 11.334 14.6673H4.66732C4.3137 14.6673 3.97456 14.5268 3.72451 14.2768C3.47446 14.0267 3.33398 13.6876 3.33398 13.334V4.00065M5.33398 4.00065V2.66732C5.33398 2.3137 5.47446 1.97456 5.72451 1.72451C5.97456 1.47446 6.3137 1.33398 6.66732 1.33398H9.33398C9.68761 1.33398 10.0267 1.47446 10.2768 1.72451C10.5268 1.97456 10.6673 2.3137 10.6673 2.66732V4.00065",
    stroke: "#293755",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6673 4.00065V13.334C12.6673 13.6876 12.5268 14.0267 12.2768 14.2768C12.0267 14.5268 11.6876 14.6673 11.334 14.6673H4.66732C4.3137 14.6673 3.97456 14.5268 3.72451 14.2768C3.47446 14.0267 3.33398 13.6876 3.33398 13.334V4.00065M5.33398 4.00065V2.66732C5.33398 2.3137 5.47446 1.97456 5.72451 1.72451C5.97456 1.47446 6.3137 1.33398 6.66732 1.33398H9.33398C9.68761 1.33398 10.0267 1.47446 10.2768 1.72451C10.5268 1.97456 10.6673 2.3137 10.6673 2.66732V4.00065",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6673 4.00065V13.334C12.6673 13.6876 12.5268 14.0267 12.2768 14.2768C12.0267 14.5268 11.6876 14.6673 11.334 14.6673H4.66732C4.3137 14.6673 3.97456 14.5268 3.72451 14.2768C3.47446 14.0267 3.33398 13.6876 3.33398 13.334V4.00065M5.33398 4.00065V2.66732C5.33398 2.3137 5.47446 1.97456 5.72451 1.72451C5.97456 1.47446 6.3137 1.33398 6.66732 1.33398H9.33398C9.68761 1.33398 10.0267 1.47446 10.2768 1.72451C10.5268 1.97456 10.6673 2.3137 10.6673 2.66732V4.00065",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6673 4.00065V13.334C12.6673 13.6876 12.5268 14.0267 12.2768 14.2768C12.0267 14.5268 11.6876 14.6673 11.334 14.6673H4.66732C4.3137 14.6673 3.97456 14.5268 3.72451 14.2768C3.47446 14.0267 3.33398 13.6876 3.33398 13.334V4.00065M5.33398 4.00065V2.66732C5.33398 2.3137 5.47446 1.97456 5.72451 1.72451C5.97456 1.47446 6.3137 1.33398 6.66732 1.33398H9.33398C9.68761 1.33398 10.0267 1.47446 10.2768 1.72451C10.5268 1.97456 10.6673 2.3137 10.6673 2.66732V4.00065",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6673 4.00065V13.334C12.6673 13.6876 12.5268 14.0267 12.2768 14.2768C12.0267 14.5268 11.6876 14.6673 11.334 14.6673H4.66732C4.3137 14.6673 3.97456 14.5268 3.72451 14.2768C3.47446 14.0267 3.33398 13.6876 3.33398 13.334V4.00065M5.33398 4.00065V2.66732C5.33398 2.3137 5.47446 1.97456 5.72451 1.72451C5.97456 1.47446 6.3137 1.33398 6.66732 1.33398H9.33398C9.68761 1.33398 10.0267 1.47446 10.2768 1.72451C10.5268 1.97456 10.6673 2.3137 10.6673 2.66732V4.00065",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6673 4.00065V13.334C12.6673 13.6876 12.5268 14.0267 12.2768 14.2768C12.0267 14.5268 11.6876 14.6673 11.334 14.6673H4.66732C4.3137 14.6673 3.97456 14.5268 3.72451 14.2768C3.47446 14.0267 3.33398 13.6876 3.33398 13.334V4.00065M5.33398 4.00065V2.66732C5.33398 2.3137 5.47446 1.97456 5.72451 1.72451C5.97456 1.47446 6.3137 1.33398 6.66732 1.33398H9.33398C9.68761 1.33398 10.0267 1.47446 10.2768 1.72451C10.5268 1.97456 10.6673 2.3137 10.6673 2.66732V4.00065",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6673 4.00065V13.334C12.6673 13.6876 12.5268 14.0267 12.2768 14.2768C12.0267 14.5268 11.6876 14.6673 11.334 14.6673H4.66732C4.3137 14.6673 3.97456 14.5268 3.72451 14.2768C3.47446 14.0267 3.33398 13.6876 3.33398 13.334V4.00065M5.33398 4.00065V2.66732C5.33398 2.3137 5.47446 1.97456 5.72451 1.72451C5.97456 1.47446 6.3137 1.33398 6.66732 1.33398H9.33398C9.68761 1.33398 10.0267 1.47446 10.2768 1.72451C10.5268 1.97456 10.6673 2.3137 10.6673 2.66732V4.00065",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6673 4.00065V13.334C12.6673 13.6876 12.5268 14.0267 12.2768 14.2768C12.0267 14.5268 11.6876 14.6673 11.334 14.6673H4.66732C4.3137 14.6673 3.97456 14.5268 3.72451 14.2768C3.47446 14.0267 3.33398 13.6876 3.33398 13.334V4.00065M5.33398 4.00065V2.66732C5.33398 2.3137 5.47446 1.97456 5.72451 1.72451C5.97456 1.47446 6.3137 1.33398 6.66732 1.33398H9.33398C9.68761 1.33398 10.0267 1.47446 10.2768 1.72451C10.5268 1.97456 10.6673 2.3137 10.6673 2.66732V4.00065",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6673 4.00065V13.334C12.6673 13.6876 12.5268 14.0267 12.2768 14.2768C12.0267 14.5268 11.6876 14.6673 11.334 14.6673H4.66732C4.3137 14.6673 3.97456 14.5268 3.72451 14.2768C3.47446 14.0267 3.33398 13.6876 3.33398 13.334V4.00065M5.33398 4.00065V2.66732C5.33398 2.3137 5.47446 1.97456 5.72451 1.72451C5.97456 1.47446 6.3137 1.33398 6.66732 1.33398H9.33398C9.68761 1.33398 10.0267 1.47446 10.2768 1.72451C10.5268 1.97456 10.6673 2.3137 10.6673 2.66732V4.00065",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6673 4.00065V13.334C12.6673 13.6876 12.5268 14.0267 12.2768 14.2768C12.0267 14.5268 11.6876 14.6673 11.334 14.6673H4.66732C4.3137 14.6673 3.97456 14.5268 3.72451 14.2768C3.47446 14.0267 3.33398 13.6876 3.33398 13.334V4.00065M5.33398 4.00065V2.66732C5.33398 2.3137 5.47446 1.97456 5.72451 1.72451C5.97456 1.47446 6.3137 1.33398 6.66732 1.33398H9.33398C9.68761 1.33398 10.0267 1.47446 10.2768 1.72451C10.5268 1.97456 10.6673 2.3137 10.6673 2.66732V4.00065",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 7.33398V11.334",
    stroke: "#293755",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 7.33398V11.334",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 7.33398V11.334",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 7.33398V11.334",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 7.33398V11.334",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 7.33398V11.334",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 7.33398V11.334",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 7.33398V11.334",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 7.33398V11.334",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 7.33398V11.334",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 7.33398V11.334",
    stroke: "#293755",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 7.33398V11.334",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 7.33398V11.334",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 7.33398V11.334",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 7.33398V11.334",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 7.33398V11.334",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 7.33398V11.334",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 7.33398V11.334",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 7.33398V11.334",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 7.33398V11.334",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash2);
export default __webpack_public_path__ + "static/media/trash-2.1fc4165ddf58087957024b48d6c9d207.svg";
export { ForwardRef as ReactComponent };